import { Component, OnInit, Input, Output } from '@angular/core';
import { ApiService } from '../../Services/Api.service';
import { AuthService } from 'src/app/Services/Auth/auth.service';
import { EventEmitter } from '@angular/core';


@Component({
	selector: 'app-focused-selector',
	templateUrl: './focusedSelector.component.html',
	styleUrls: ['./focusedSelector.component.scss']
})
export class focusedSelectorComponent implements OnInit {
	@Input() id_category: string;
	@Output() continue = new EventEmitter();
	focused = [];
	focus: any;
	currentFocus = this.authService.user.focus.data.id;
	currentUser = this.authService.user;
	loading=false;
	constructor(public apiService: ApiService, public authService: AuthService) { }

	ngOnInit() {
		this.apiService.get('focuses?from_quizzes=true&category=' + this.id_category).then((resp) => {
			let i=0
			resp.data.map(item => {
				this.focused.push({
					id: item.id,
					type: item.name,
					description: item.description,
					active: item.id == this.currentFocus ? true : false,
					img: item.img ? item.img : 'assets/images/logo-blue.png'
				})
			});
		});
	}

	onChoseFocus(focus) {
		this.focus = focus;
		var indexNum = this.focused.findIndex((element) => {
			return (element.id == focus.id);
		});
		this.focused = this.focused.map((item) => {
			item.active = false;
			return item;
		});
		if (!this.focused[indexNum].active) {
			this.focused[indexNum].active = true;
		} else {
			this.focused[indexNum].active = !this.focused[indexNum].active;
		}
	}

	async onSaveFocused() {
		this.loading=true;
		let self=this;
		if (this.focus){
			let saved = await this.apiService.put('users/' + this.currentUser.id, {
				focus: this.focus.id,
			}).then(resp=>{
				this.loading=false
				self.authService.saveUserData()
			});
		}
		//let s = await self.authService.saveUserData();
		
		this.continue.emit(null);
	}

}
